import { render, staticRenderFns } from "./topBannerDetail.vue?vue&type=template&id=3745080c&scoped=true"
import script from "./topBannerDetail.vue?vue&type=script&lang=js"
export * from "./topBannerDetail.vue?vue&type=script&lang=js"
import style0 from "./topBannerDetail.vue?vue&type=style&index=0&id=3745080c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3745080c",
  null
  
)

export default component.exports